import {
  Booking,
  BookingPartecipant,
  BookingWithWordpressHolidayData,
  CustomerBookingRequestParams,
  CustomerBookingsRequestParams,
  PayBookingResponse,
  UpdateBookingPartecipantRequest,
} from '@interfaces/booking.interface';
import { CountResponse } from '@interfaces/common.interface';

import api from './';

export const {
  useFindManyCustomerBookingsQuery,
  useCountCustomerBookingsQuery,
  useFindOneQuery,
  useUpdateBookingPartecipantMutation,
  usePayBookingMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    findManyCustomerBookings: build.query<
      Booking[],
      CustomerBookingsRequestParams
    >({
      query: (params) => ({
        url: `bookings`,
        method: 'GET',
        params,
      }),
      providesTags: ['bookings'],
    }),
    countCustomerBookings: build.query<CountResponse, void>({
      query: () => ({
        url: `bookings/count`,
        method: 'GET',
      }),
      providesTags: ['bookings'],
    }),
    findOne: build.query<
      BookingWithWordpressHolidayData,
      CustomerBookingRequestParams
    >({
      query: ({ id }) => ({
        url: `bookings/${id}`,
        method: 'GET',
      }),
      providesTags: ['bookings'],
    }),
    updateBookingPartecipant: build.mutation<
      BookingPartecipant,
      UpdateBookingPartecipantRequest
    >({
      query: ({ id, partecipantId, body }) => ({
        url: `bookings/${id}/partecipants/${partecipantId}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['bookings'],
    }),
    payBooking: build.mutation<PayBookingResponse, number>({
      query: (id) => ({
        url: `bookings/${id}/pay`,
        method: 'POST',
      }),
    }),
  }),
});
